import { Route, Routes } from "react-router-dom";
import { PostsPage } from "./page/PostsPage";
import { PostDetail } from "./page/PostDetail";

export default function Posts() {
  return (
    <Routes>
      <Route path="" element={<PostsPage />} />
      <Route path=":id" element={<PostDetail />} />
    </Routes>
  );
}
